import { User } from '@auth0/auth0-react'
import { sendMetric } from '../../../api'
import { Location, MetricDestinations } from '../../../api/models'

export async function sendDeleteLocationChangeMetric(location: Location | undefined, user: User | undefined): Promise<void> {
  sendMetric({
    tableName: 'monitoring-location-change',
    destinations: [MetricDestinations.audit],
    metricName: 'location_change_delete',
    metricType: 'inc',
    value: 1,
    tags: {
      sid: location ? location?.id : 'Unknown',
      user: user?.name ?? 'Unknown',
      date_deleted: new Date().toISOString()
    }
  })
}

export async function sendUpdateLocationChangeMetric(location: Location | undefined, user: User | undefined, effectiveAt: string): Promise<void> {
  await sendMetric({
    tableName: 'monitoring-location-change',
    destinations: [MetricDestinations.audit],
    metricName: 'location_change_update',
    metricType: 'inc',
    value: 1,
    tags: {
      sid: location ? location.id : 'Unknown',
      user: user?.name ?? 'Unknown',
      change_date: new Date().toISOString(),
      address_effective_date: effectiveAt
    }
  })
}

export async function sendCreateLocationChangeMetric(location: Location | undefined, user: User | undefined, effectiveAt: string): Promise<void> {
  await sendMetric({
    tableName: 'monitoring-location-change',
    destinations: [MetricDestinations.audit],
    metricName: 'location_change_add',
    metricType: 'inc',
    value: 1,
    tags: {
      sid: location ? location.id : 'Unknown',
      user: user?.name ?? 'Unknown',
      change_date: new Date().toISOString(),
      address_effective_date: effectiveAt
    }
  })
}

export async function sendLocationChangeValidationErrorMetric(
  user: User | undefined,
  sid: string | undefined,
  issueAndCorrectionText: string[]
): Promise<void> {
  await sendMetric({
    tableName: 'admin-review-tool',
    destinations: [MetricDestinations.audit],
    metricName: 'location_change_validation_error',
    metricType: 'inc',
    value: 1,
    tags: {
      sid: sid ?? 'Unknown',
      user: user?.name ?? 'Unknown',
      date: new Date().toISOString(),
      address_validation_errors: issueAndCorrectionText
    }
  })
}
